export default "__VITE_ASSET__aw6aPwWK__"